import React from "react";
import { motion } from "framer-motion";

const easeOut = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: easeOut, delay }}
    >
      {children}
    </motion.div>
  );
}

// Masked line reveal for headings (kinetic on-load moment).
export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className="reveal-mask">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.9, ease: easeOut, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}
